<template>
    <h4>DocCompHosting.vue</h4>
    <div>
      <Doccmp :PersonID="personID"></Doccmp>
    </div>

</template>

<script>
import Doccmp from "../../../components/dataSupport/DocCmp.vue";

export default {
  data() {return{
    personID: 35292,
  };},
  created() {},
  components: { Doccmp },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
